module.exports = __webpack_public_path__ + "static/media/ilhasturkscaicos.2912d0ed.jpg";